module.exports = __webpack_public_path__ + "static/graphiql-3562b15be52f7cb32cae224f946bba4d.png";